import { redirect } from '@tanstack/react-router';

import { getAuthSession, type AuthState, type ChallengeFlow } from './auth-session';

/** Rota de cada desafio, como o `navigateToFlow` do legado. */
export const CHALLENGE_ROUTES = {
  mfa: '/login/mfa',
  mfaSetup: '/login/mfa/setup',
  newPassword: '/login/confirmar-senha',
} as const satisfies Record<ChallengeFlow, string>;

/** Para onde a tela de login deve ir com este estado; `undefined` = ficar. */
export function routeForState(state: AuthState): string | undefined {
  if (state.status === 'challenge' && state.challenge) return CHALLENGE_ROUTES[state.challenge];
  return undefined;
}

/**
 * Guarda de rota para `beforeLoad` das rotas autenticadas. Espera a restauração da sessão; sem
 * sessão, guarda o destino e manda para `/login`; com desafio pendente, para a tela do desafio.
 */
export async function requireAuth({ location }: { location: { href: string } }): Promise<{ auth: AuthState }> {
  const session = getAuthSession();
  const state = await session.ready().then(() => session.getState());
  if (state.status === 'signedIn') return { auth: state };
  if (state.status === 'challenge' && state.challenge) {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- contrato do TanStack Router
    throw redirect({ to: CHALLENGE_ROUTES[state.challenge] });
  }
  session.setRedirect(location.href);
  // eslint-disable-next-line @typescript-eslint/only-throw-error -- contrato do TanStack Router
  throw redirect({ to: '/login' });
}
